/* eslint-disable no-console */
import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CarteleriaForm, CarteleriaList } from "../../components";
import { useAuthContext } from "../../context/auth";
import adigitalLogo from "../../img/adigital-logo.png";
import screenmediaLogo from "../../img/screenmedia-logo.png";
import visionaLogo from "../../img/visiona-logo.png";
import wecastLogo from "../../img/wecast-logo.png";
import "./stylesCarteleriaPage.scss";

const CarteleriaPage = () => {
  const [selectedNegocioId, setSelectedNegocioId] = useState(null);
  const { pais } = useAuthContext();
  const navigate = useNavigate();
  const [refreshKey, setRefreshKey] = useState(0);

  const logos = {
    Chile: wecastLogo,
    Perú: visionaLogo,
    Uruguay: screenmediaLogo,
    Region: adigitalLogo,
  };

  const handleEdit = (id) => {
    setSelectedNegocioId(id);
  };

  const handleNew = () => {
    setSelectedNegocioId(null);
  };

  const handleRefresh = () => {
    setRefreshKey((prev) => prev + 1);
  };

  const logo = useMemo(() => logos[pais] || visionaLogo, [pais]);

  return (
    <div className="carteleria-page">
      <div className="logo-container">
        <img src={logo} alt="Logo" className="logo" onClick={() => navigate("/admin")} />
      </div>
      <div className="carteleria-sections">
        <div className="carteleria-form-section">
          <CarteleriaForm selectedNegocioId={selectedNegocioId} onSuccess={handleRefresh} />
        </div>
        <div className="carteleria-list-section">
          <CarteleriaList key={refreshKey} onEdit={handleEdit} onNew={handleNew} />
        </div>
      </div>
    </div>
  );
};

export default CarteleriaPage;
